import type { ITotalLabelTheme } from '@visactor/vchart';

export const totalLabel: ITotalLabelTheme = {
  visible: false,
  offset: 5
};
